export default __webpack_public_path__ + "static/media/ChangeUp.e9e92db4.svg";